module.exports = __webpack_public_path__ + "static/media/add-icon.c9b9dab7.svg";